<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="selectedUrl ? `/request/${inputs.id}` : '/request'"
      >
        <div class="row">
          <div class="col-md-12">
            <app-note
              class="mb-primary"
              title="Información"
              content-type="html"
              :notes="[$store.getters.getTag('2.O')]"
            />
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>SECTOR</label>
              <multiselect
                v-model="inputs.level2"
                :options="scopes.level2"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12" style="margin-top: 90px" >
            <div class="form-group">
              <label>NOMBRE DEL PROGRAMA (1)</label>
              <quill-editor
              v-model="inputs.level7"
              :options="editorOption"
              :disabled="status"
            />
              <!--<app-input
                type="textarea"
                v-model="inputs.level7"
                :required="true"
                placeholder="Ingrese el nombre del programa"
              /> -->
            </div>
          </div>
          <br /><br /><br /><br /><br />

          <div class="col-12" style="margin-top: 90px" >
            <div class="form-group">
              <label>ENSAYO / MAGNITUD G(2)</label>
              <quill-editor
              v-model="inputs.level8"
              :options="editorOption"
              :disabled="status"
              />
              <!--
              <app-input
                type="textarea"
                v-model="inputs.level8"
                :required="true"
                placeholder="Ingrese ensayo / magnitud"
              /> -->
            </div>
          </div>
          <br /><br /><br /><br /><br />

          <div class="col-12" style="margin-top: 90px" >
            <div class="form-group">
              <label>ÍTEM DE ENSAYO DE APTITUD (3)</label>
              <quill-editor
              v-model="inputs.level9"
              :options="editorOption"
              :disabled="status"
              />
              <!--
              <app-input
                type="textarea"
                v-model="inputs.level9"
                :required="true"
                placeholder="Ingrese el ítem de ensayo de aptitud"
              /> -->
            </div>
          </div>
          <br /><br /><br /><br /><br />

          <div class="col-12" style="margin-top: 90px" >
            <div class="form-group">
              <label>FRECUENCIA (4)</label>
              <quill-editor
              v-model="inputs.level10"
              :options="editorOption"
              :disabled="status"
              />
              <!--
              <app-input
                type="textarea"
                v-model="inputs.level10"
                :required="true"
                placeholder="Ingrese la frecuencia"
              /> -->
            </div>
          </div>
          <br /><br /><br /><br /><br />

          <div class="col-12" style="margin-top: 90px" >
            <div class="form-group">
              <label>MÉTODO PARA ESTABLECER EL VALOR ASIGNADO (5)</label>
               <quill-editor
              v-model="inputs.level11"
              :options="editorOption"
              :disabled="status"
              />
              <!--
              <app-input
                type="textarea"
                v-model="inputs.level11"
                :required="true"
                placeholder="Ingrese el método para establecer el valor asignado"
              /> -->
            </div>
          </div>
          <br /><br /><br /><br /><br />


        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import Multiselect from "vue-multiselect";
import LiquorTree from "liquor-tree";
import { quillEditor } from "vue-quill-editor";

export default {
  components: { Multiselect, LiquorTree , quillEditor},
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    selectedUrl: String,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      scopes: {
        level2: [],
      },
      modalId: "add-edit-modal",
      disabledSubmit: false,
            editorOption: {
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline"],
            [{ align: [] }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ color: [] }, { background: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
          ],
        },
        theme: "snow", // or 'bubble'
      },
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? "Editar" : "Registrar";
    },
  },
  created() {
    this.getData();
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      const tmp = {
        ...this.inputs,
        acc_app_id: this.$store.state.accreditation.id,
      };

      tmp.level2 = this.getId(tmp.level2);

      if (
        !tmp.level7 ||
        !tmp.level8 ||
        !tmp.level9 ||
        !tmp.level10 ||
        !tmp.level11
      ) {
        this.$toastr.e("Todos los campos son obligatorios");
        return;
      }

      this.disabledSubmit = true;
      this.save(tmp);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      if (this.inputs.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.preloader = false;

      const tmp = {};
      tmp.id = response.data.id;

      tmp.level2 = response.data.level_2;
      tmp.level7 = response.data.level7;
      tmp.level8 = response.data.level8;
      tmp.level9 = response.data.level9;
      tmp.level10 = response.data.level10;
      tmp.level11 = response.data.level11;

      this.inputs = tmp;
    },

    getData() {
      this.preloader = true;

      this.axiosGet(
        `request/options?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            const { scopes } = response.data;
            this.scopes = scopes;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    getId(item) {
      return item ? item.id : null;
    },
  },
};
</script>
